import { useAutoAnimate } from "@formkit/auto-animate/react";

export const useAnimate = () =>
  useAutoAnimate({
    duration: 200,
    easing: "cubic-bezier(0.4, 0, 0.2, 1)",
  });
